import { Button, makeStyles } from '@material-ui/core';
import { teal } from '@material-ui/core/colors';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSomeState } from '../../albCommonModule';
import { 
  getLodingStatus, parsePermission, fdp, null2Zero, formatNum, formatDate 
} from '../../commonModule';
import BarChartIcon from '@material-ui/icons/BarChart';
import { 
  LoadErr, LoadingSpinner, PermissionDenied, SendBillingToSomeState 
} from '../common/commonParts';
import { ProseedLinksTab } from './Proseed';

const useStyles = makeStyles({
  company :{width: '100%', fontSize: 12, color: teal[900], paddingBottom: 2},
});

// オブジェクトを配列化する
const toArray = (v) => {
  if (Array.isArray(v)) return v;
  const r = [];
  Object.keys(v).forEach(e=>{
    if ((typeof v[e]) !== 'object') return null;
    if (Array.isArray(v[e])) return null;
    if (!Object.keys(v[e]).length)  return null;
    r.push(v[e]);
  });
  return r;
}

const MainProseedOtherOfficeis = () => {
  const classes = useStyles();
  const allstate = useSelector(state=>state);
  const {stdDate, accountLst} = allstate;
  // const stdDate = useSelector(state=>state.stdDate);
  // const accountLst = useSelector(state=>state.accountLst);
  const [fetchStatus, setFetchStatus] = useState(
    {count:accountLst.length ,loaded: 0, nodata: 0, error: 0}
  );
  const todayStr = formatDate(new Date(), 'YYYY-MM-DD');
  const [res, setRes] = useState({});
  const [officeis, setOfficeis] = useState(()=>{
    return accountLst.map(e=>e);
  });
  
  // 月が変わったときに他事業所売上情報正気化
  useEffect(()=>{
    return () => {
      const t = officeis;
      t.forEach(e=>{
        e.userSanteiTotal = 0;
      });
      setOfficeis(t);
    }
    
  }, [stdDate])

  useEffect(()=>{
    if (Object.keys(res).length){
      if (!res.data.result){
        const t = {...fetchStatus};
        t.error++;
        setFetchStatus(t);
      }
      else if (!res.data.dt.length){
        const t = {...fetchStatus};
        t.nodata++;
        setFetchStatus(t);
      }
      else{
        const t = {...fetchStatus};
        t.loaded++;
        setFetchStatus(t);
        // 他事業所の売上データ取得
        const b = fdp(res.data.dt[0], 'state.billingDt', []);
        const bdt = toArray(b); // fdpを通しているのでオブジェクトで戻ってくる！
        let loaded = res.data.dt[0].timestamp.slice(0, 10);
        loaded = (loaded === todayStr)
        ?res.data.dt[0].timestamp.slice(11, 20): loaded;
        const thisBid = res.data.dt[0].bid;
        const thisHid = res.data.dt[0].hid;
        const userSanteiTotal = bdt.reduce((v, e)=>(v + e.userSanteiTotal), 0);
        const countOfUse = bdt.reduce((v, e)=>(v + e.countOfUse), 0);
        const tanniTotal = bdt.reduce((v, e)=>(v + e.tanniTotal), 0);
        const ketteigaku = bdt.reduce((v, e)=>(v + e.ketteigaku), 0);
        const jichiJosei = bdt.reduce((v, e)=>(v + e.jichiJosei), 0);
        const actualCost = bdt.reduce((v, e)=>(v + e.actualCost), 0);
        const p = officeis.findIndex(e=>(e.bid === thisBid && e.hid === thisHid));
        const u = [...officeis];
        u[p].userSanteiTotal = userSanteiTotal;
        u[p].countOfUse = countOfUse;
        u[p].tanniTotal = tanniTotal;
        u[p].ketteigaku = ketteigaku;
        u[p].jichiJosei = jichiJosei;
        u[p].actualCost = actualCost;
        u[p].loaded = loaded;
        setOfficeis(u);
      }
    }
  }, [res]);
  // 数字整形のエイリアス
  const fmtNum = (v) => (formatNum(null2Zero(v), 1));
  const companySet = new Set([...officeis].filter(e=>e.userSanteiTotal).map(e=>e.hid));
  const multiCamp = companySet.size > 1; // 複数法人表示
  let preHname = '';
  let n = 1;
  const officeisProseeds = officeis.map((e, i)=>{
    if (!e.userSanteiTotal) return null;
    let displayHname = false;
    if (multiCamp && preHname !== e.hname){
      displayHname = true;
      preHname = e.hname;
    }
    const kokuho = e.userSanteiTotal - e.ketteigaku - null2Zero(e.jichiJosei);
    return (
      <div className='flxRow lower' key={i} >
        <div className='wmin lowerRight'>{n++}</div>
        <div className='w15'>
          {displayHname === true &&
            <div className={classes.company}>{e.shname}</div>
          }
          {e.sbname}
        </div>
        <div className='w10 lowerRight'>{fmtNum(e.tanniTotal)}</div>
        <div className='w10 lowerRight'>{fmtNum(e.userSanteiTotal)}</div>
        <div className='w10 lowerRight'>{fmtNum(e.ketteigaku)}</div>
        <div className='w07 lowerRight'>{fmtNum(e.actualCost)}</div>
        <div className='w10 lowerRight'>{fmtNum(kokuho)}</div>
        <div className='w05 lowerRight'>{fmtNum(e.countOfUse)}</div>
        <div className='w10 lowerRight'>{e.loaded}</div>
      </div>

    )
  });
  const displayLength = officeis.filter(e=>e.userSanteiTotal).length;
  const titleStyle = {
    position: 'sticky', top: 82, paddingTop: 16, background: '#fff',
    zIndex: 90,
  }
  const Title = () => {
    if (!displayLength) return null;
    return (
      <div className='flxTitle' style={titleStyle}>
        <div className='wmin'>No</div>
        <div className='w15'>事業所名</div>
        <div className='w10'>単位数</div>
        <div className='w10'>算定額</div>
        <div className='w10'>利用者負担</div>
        <div className='w07'>実費</div>
        <div className='w10'>国保請求</div>
        <div className='w05'>利用数</div>
        <div className='w10'>更新日/時刻</div>
      </div>
    )
  }
  const handleClick = () => {
    const f = async (e) => {
      const prms = {
        hid: e.hid, bid: e.bid, date: stdDate,
        item: 'billingDt',
      };
      const r = await fetchSomeState(prms);
      setRes(r);
    }
    accountLst.forEach(e=>{
      const permission = parsePermission(e)[0][0];
      if (permission >= 90){
        f(e);
      }
    });
  }
  const FetchButton = () => {
    const style = {
      padding: 8, textAlign: 'center', paddingBottom: 24, position: 'relative',
    }
    const sendButtonStyle = {
      position: 'absolute', top:8, right: 8,
    }

    return (<>
      <div style={style}>
        <div style={sendButtonStyle}>
          <SendBillingToSomeState sendAnyTime={false} displayButton={true}/>
        </div>
        <Button
          variant='contained'
          onClick={handleClick}
          startIcon={<BarChartIcon/>}
        >
          売上情報取得
        </Button>
      </div>
      </>)
  }
  const contentStyle = {maxWidth: 900, margin:'96px auto 40px'};
  return (<>
    <ProseedLinksTab/>
    <div style={contentStyle} className='proseedOthers'>
      <FetchButton />
      <Title/>
      {officeisProseeds}
    </div>
  </>)

}

const ProseedOtherOfficeis = ()=>{
  const allstate = useSelector(state=>state);
  const loadingStatus = getLodingStatus(allstate);
  const account = useSelector(state => state.account);
  const permission = parsePermission(account)[0][0];

  if (loadingStatus.loaded && permission >= 90){
    return(<>
      <MainProseedOtherOfficeis />
    </>)
  }
  else if (loadingStatus.error){
    return (<>
      <LoadErr loadStatus={loadingStatus} errorId={'E5966'} />
    </>)
  }
  else if (permission < 90) return <PermissionDenied marginTop='90'/>
  else{
    return(<>
     <LoadingSpinner/>
    </>)
  }
}
export default ProseedOtherOfficeis;